/* eslint-disable */
import moment from "moment";
import Flowit from "../../../services/flowit";
import { state } from "./mutations";
import * as types from "./types";

// eslint-disable-next-line no-unused-vars
export const hideFilters = ({ commit }) => {
  commit(types.FILTER_STATUS, false);
};

export const resetFilters = ({ commit }) => {
  commit(types.SET_PAYMENTS_LIST, []);
  commit(
    types.SET_FILTER_INITIAL_DATE,
    moment()
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_FINAL_DATE,
    moment()
      .endOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_PAYMENT_INITIAL_DATE,
    moment()
      .startOf("year")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_PAYMENT_FINAL_DATE,
    moment()
      .endOf("year")
      .format("YYYY-MM-DD")
  );
  commit(types.SET_FILTER_CARD_BRAND, "");
  commit(types.SET_FILTER_TERMINAL_NUMBER, "");
  commit(types.SET_FILTER_NSU_ACQUIRER, "");
  commit(types.SET_FILTER_STATUS, "");
  commit(types.SET_FILTER_OPERATION, "");
  commit(types.SET_FILTER_ORDINATION, "");
  commit(types.SET_FILTER_ORDINATION, "");
  commit(types.SET_FILTER_MIN_AMOUNT, null);
  commit(types.SET_FILTER_MAX_AMOUNT, null);
  commit(types.FILTER_PARAMS, { 
      page: 1,
      limit: 10,
      filterrific: {
        with_created_at_between: {
          start_at: null,
          end_at: null,
        },
        status: null,
        credit_card_brand: null,
        with_terminal_number: null,
        operation: null,
        with_partner: null,
        sorted_by: null,
        with_amount_gteq: null,
        with_amount_lteq: null,
      },
      nsu_acquirer_cont: null  
    }
  );
};

export const loadList = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.payments
    .loadList(params)
    .then(response => {
      commit(types.LOAD_LIST, response.data.payments);
      commit(types.SET_PAYMENTS_SUBTOTAL, response.data.subtotal || 0);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.SET_PAYMENTS_SUBTOTAL, 0);
      commit(types.LOAD, false);
    });
};

export const load = ({ commit, state }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  
  // Use state.filterParams if no params provided
  let requestParams = params || state.filterParams;
  
  // Convert reactive objects to plain objects
  if (requestParams && typeof requestParams === 'object') {
    requestParams = JSON.parse(JSON.stringify(requestParams));
  }
  
  Flowit.payments
    .loadList(requestParams)
    .then(response => {
      commit(types.LOAD_LIST, response.data.payments);
      commit(types.SET_PAYMENTS_SUBTOTAL, response.data.subtotal || 0);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.SET_PAYMENTS_SUBTOTAL, 0);
      commit(types.LOAD, false);
    });
};

export const getPayment = ({ commit }, paymentId) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.payments.get(paymentId).then(response => {
    commit(types.GET_PAYMENT, response.data.payment);
    commit(types.LOAD, false);
  });
};

export const exportPayments = ({ commit }, params) => {
  commit(types.LOAD, true);
  Flowit.payments.exportPayments(params).then(response => {});
  commit(types.LOAD, false);
};

export const downloadExport = ({ commit }, params) => {
  return Flowit.payments.downloadExport(params).then(response => {
    if (response.data.download_url) {
      // Create a temporary link and click it to download
      const link = document.createElement('a');
      link.href = response.data.download_url;
      link.download = params.file_name || 'payments_export.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    return response;
  });
};

export const checkExportStatus = ({ commit }) => {
  return Flowit.payments.checkExportStatus();
};

export const newPayment = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.payments.newPayment(params).then(
    response => {
      commit(types.NEW_PAYMENT_RESPONSE, response.data.payment);
      commit(types.SUCCESS_STATUS, true);
      commit(types.LOAD, false);
    },
    error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.LOAD, false);
    }
  );
};

export const loadListSubscriptions = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.payments
    .loadListSubscriptions(params)
    .then(response => {
      commit(types.LOAD_LIST_SUBSCRIPTIONS, response.data.subscriptions);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.SET_PAYMENTS_SUBTOTAL, 0);
      commit(types.LOAD, false);
    });
};

export const updateSubscription = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  commit(types.NEW_PAYMENT_STATUS, false);
  commit(types.NEW_PAYMENT_ERROR, false);
  Flowit.payments
    .updateSubscription(params)
    .then(response => {
      commit(types.UPDATE_SUBSCRIPTION, response.data.subscription);
      commit(types.NEW_PAYMENT_STATUS, true);
      commit(types.NEW_PAYMENT_ERROR, false);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {
      // console.log(error);
      commit(types.UPDATE_SUBSCRIPTION, error.response.data);
      commit(types.NEW_PAYMENT_ERROR, true);
      commit(types.NEW_PAYMENT_STATUS, false);
      commit(types.LOADING_DATA, false);
    });
};

export const loadFilters = ({ commit, state }) => {
  commit(
    types.SET_FILTER_INITIAL_DATE,
    moment()
      .startOf("year")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_FINAL_DATE,
    moment()
      .endOf("year")
      .format("YYYY-MM-DD")
  );
  commit(types.SET_FILTER_PAYMENT_INITIAL_DATE, null);
  commit(types.SET_FILTER_PAYMENT_FINAL_DATE, null);
  commit(types.LIMIT, 1000);
};

// eslint-disable-next-line no-unused-vars
export const setInitialDate = ({ commit }, date) => {
  commit(types.SET_FILTER_INITIAL_DATE, date);
};
// eslint-disable-next-line no-unused-vars
export const setFinalDate = ({ commit }, date) => {
  commit(types.SET_FILTER_FINAL_DATE, date);
};
// eslint-disable-next-line no-unused-vars
export const setPaymentInitialDate = ({ commit }, date) => {
  commit(types.SET_FILTER_PAYMENT_INITIAL_DATE, date);
};
// eslint-disable-next-line no-unused-vars
export const setPaymentFinalDate = ({ commit }, date) => {
  commit(types.SET_FILTER_PAYMENT_FINAL_DATE, date);
};

export const setCardBrand = ({ commit }, cardBrand) => {
  commit(types.SET_FILTER_CARD_BRAND, cardBrand);
};

export const setTerminalNumber = ({ commit }, terminalNumber) => {
  commit(types.SET_FILTER_TERMINAL_NUMBER, terminalNumber);
};

export const setNsuAcquirer = ({ commit }, param) => {
  commit(types.SET_FILTER_NSU_ACQUIRER, param);
};

export const setStatus = ({ commit }, model) => {
  commit(types.SET_FILTER_STATUS, model.business);
};
export const setOperation = ({ commit }, operation) => {
  commit(types.SET_FILTER_OPERATION, operation.business);
};
export const setOrdination = ({ commit }, ordination) => {
  commit(types.SET_FILTER_ORDINATION, ordination.business);
};

export const setTotalResources = ({ commit }, total) => {
  commit(types.SET_TOTAL_RESOURCES, total);
};

export const setLimit = ({ commit }, param) => {
  commit(types.LIMIT, param);
};

export const setCurrentPage = ({ commit }, param) => {
  commit(types.CURRENT_PAGE, param);
  commit(types.PAGE, param);
};

export const setLoadingData = ({ commit }, status) => {
  commit(types.LOADING_DATA, status);
};
export const showFilters = ({ commit }, param) => {
  commit(types.SHOW_FILTERS, param);
};

export const setPartner = ({ commit }, model) => {
  commit(types.SET_FILTER_PARTNER, model.business);
};
export const setMinAmount = ({ commit }, param) => {
  commit(types.SET_FILTER_MIN_AMOUNT, param);
};
export const setMaxAmount = ({ commit }, param) => {
  commit(types.SET_FILTER_MAX_AMOUNT, param);
};
export const setStartAt = ({ commit }, param) => {
  commit(types.SET_FILTER_INITIAL_DATE, param);
};
